export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "什么是漫画分类大全？",
    a: "漫画分类大全是一份系统梳理漫画类型的总览，涵盖热血冒险、恋爱言情、悬疑推理、玄幻修仙、科幻机甲等多种题材分类，帮助你快速了解漫画世界的丰富类型并找到感兴趣的方向。",
  },
  {
    q: "如何使用漫画排行榜大全？",
    a: "漫画排行榜大全根据人气值、评分与口碑综合排序，集中展示当下最热门的漫画作品。你可以按人气排行快速了解大家都在追什么，也能通过分类页筛选特定题材的作品。",
  },
  {
    q: "漫画类型大全和漫画题材分类有什么区别？",
    a: "漫画类型大全侧重从整体类型角度对漫画进行分类梳理，而漫画题材分类则更关注具体的题材与内容方向。两者相互补充，共同构成完整的漫画分类体系，方便你多角度查找漫画。",
  },
  {
    q: "网站上的漫画可以免费阅读吗？",
    a: "本站是漫画分类与推荐导航平台，主要提供漫画分类大全、类型大全、排行榜大全与推荐大全等导航信息，帮助你找到想看的漫画。具体阅读请前往对应作品的官方授权平台。",
  },
  {
    q: "如何找到更多漫画推荐大全？",
    a: "你可以通过首页的分类导航进入各个题材分类页，也可以在文章页查看我们精心整理的漫画推荐大全。我们还会定期更新排行榜与人气数据，欢迎持续关注。",
  },
  {
    q: "发现漫画信息有误如何反馈？",
    a: "如果你发现漫画的分类、简介或排行信息有误，欢迎通过「关于我们」页面提供的联系方式向我们反馈，我们会尽快核实并修正。",
  },
];